/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaGNVertSecuredConfiguration } from '../shiva-gn-vert-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { searchTicketListCustom$Any } from '../fn/ticketing/search-ticket-list-custom-any';
import { SearchTicketListCustom$Any$Params } from '../fn/ticketing/search-ticket-list-custom-any';
import { searchTicketListCustom$Json } from '../fn/ticketing/search-ticket-list-custom-json';
import { SearchTicketListCustom$Json$Params } from '../fn/ticketing/search-ticket-list-custom-json';
import { TicketGnvPagedList } from '../models/ticket-gnv-paged-list';


/**
 * All about the incident tickets
 */
@Injectable({ providedIn: 'root' })
export class TicketingService extends BaseService {
  constructor(config: ShivaGNVertSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `searchTicketListCustom()` */
  static readonly SearchTicketListCustomPath = '/custom/tickets/search';

  /**
   * search GNVert tickets.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchTicketListCustom$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchTicketListCustom$Json$Response(params?: SearchTicketListCustom$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<TicketGnvPagedList>> {
    return searchTicketListCustom$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * search GNVert tickets.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchTicketListCustom$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchTicketListCustom$Json(params?: SearchTicketListCustom$Json$Params, context?: HttpContext): Observable<TicketGnvPagedList> {
    return this.searchTicketListCustom$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<TicketGnvPagedList>): TicketGnvPagedList => r.body)
    );
  }

  /**
   * search GNVert tickets.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchTicketListCustom$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchTicketListCustom$Any$Response(params?: SearchTicketListCustom$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<TicketGnvPagedList>> {
    return searchTicketListCustom$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * search GNVert tickets.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchTicketListCustom$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchTicketListCustom$Any(params?: SearchTicketListCustom$Any$Params, context?: HttpContext): Observable<TicketGnvPagedList> {
    return this.searchTicketListCustom$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<TicketGnvPagedList>): TicketGnvPagedList => r.body)
    );
  }

}
